import { useMemo } from "react";
import { usePortfolioProductCategoriesQuery } from "web_myplann/Api/Portfolio/Queries/usePortfolioProductCategoriesQuery";
import type { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import type { FlatRowSelectOption } from "web_myplann/Shared/Components/FlatRow/FlatRowSelect";

export const useProductCategoryOptions = (
	domain: ClientPortfolioDomainEnum,
): FlatRowSelectOption<number>[] => {
	const { data } = usePortfolioProductCategoriesQuery(domain);

	return useMemo(
		() =>
			(data?.data ?? []).map((category) => ({
				value: category.id,
				label: category.name,
			})),
		[data],
	);
};
